import { cB as n, cM as r } from "./ghl-ui.es384.js";
import { fadeInTransition as i } from "./ghl-ui.es1351.js";
const t = n("loading-bar-container", `
 z-index: 5999;
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 height: 2px;
`, [i({
  enterDuration: "0.3s",
  leaveDuration: "0.8s"
}), n("loading-bar", `
 width: 100%;
 transition:
 max-width 4s linear,
 background .2s linear;
 height: var(--n-height);
 `, [r("starting", `
 background: var(--n-color-loading);
 `), r("finishing", `
 background: var(--n-color-loading);
 transition:
 max-width .2s linear,
 background .2s linear;
 `), r("error", `
 background: var(--n-color-error);
 transition:
 max-width .2s linear,
 background .2s linear;
 `)])]);
export {
  t as default
};
